export enum SubmissionsFilter {
    STATUS = 'status',
    TOPICS = 'topics',
    TRACKS = 'tracks',
    SUBMISSION_GROUPS = 'submissionGroups',
    TPC_GROUPS = 'tpcGroups',
    COLOR_SCHEME = 'colorScheme',
}
